/* Tradewear UI tweaks -- behaviour layer. Pairs with tw-ui-tweaks.css.
 *
 * One job: on mobile, lift the product title / vendor / review badge above the
 * gallery, and drop the price down next to the quantity selector. The gallery
 * and the product form are sibling containers and the split point is in the
 * middle of .product-meta, so CSS `order` cannot express this -- the nodes have
 * to move.
 *
 * Hard constraints learned the hard way on this theme:
 *   - Every node must stay INSIDE the product <section>. theme.js resolves
 *     .price-list and .product-meta__sku via ProductSection.element.querySelector,
 *     so a node moved outside the section stops updating on variant change.
 *     Both destinations here are inside it.
 *   - No document-wide MutationObserver. One added earlier starved rendering on
 *     this storefront (readyState stuck at "loading" for 24s+). Timed passes
 *     instead.
 *   - Fails open: any error and the page keeps the theme's own layout.
 *
 * Reversible: the original parent and next sibling of every moved node are
 * recorded, so crossing the breakpoint puts the desktop layout back exactly.
 */
(function () {
  'use strict';

  if (window.__twUiTweaks) return;
  window.__twUiTweaks = true;
  window.__twUiVersion = 1; // bump on every change; lets a deploy be verified from the page

  var MOBILE_QUERY = '(max-width: 999px)';

  // Kept in the theme's own visual order: title, vendor, then review badge.
  var HEAD_SELECTORS = [
    'h1.product-meta__title',
    '.product-meta__reference',
    '.product-meta__reviews-badge'
  ];

  var moved = [];  // {el, parent, next} -- enough to put everything back
  var headBox = null;

  function remember(el) {
    for (var i = 0; i < moved.length; i++) {
      if (moved[i].el === el) return;
    }
    moved.push({ el: el, parent: el.parentNode, next: el.nextSibling });
  }

  function applyMobileOrder() {
    var wrapper = document.querySelector('.product-block-list__wrapper');
    if (!wrapper) return;

    var gallery = wrapper.querySelector('.product-block-list__item--gallery');
    if (!gallery || gallery.parentNode !== wrapper) return;

    if (!headBox) {
      headBox = document.createElement('div');
      headBox.className = 'tw-mobile-product-head';
    }
    if (headBox.parentNode !== wrapper || headBox.nextSibling !== gallery) {
      wrapper.insertBefore(headBox, gallery);
    }

    for (var i = 0; i < HEAD_SELECTORS.length; i++) {
      var el = document.querySelector(HEAD_SELECTORS[i]);
      if (!el || el.parentNode === headBox) continue;
      remember(el);
      headBox.appendChild(el);
    }

    // .product-form__info-list holds the quantity selector.
    var price = document.querySelector('.product-meta__label-list');
    var infoList = document.querySelector('.product-form__info-list');
    if (price && infoList && infoList.parentNode && price.nextSibling !== infoList) {
      remember(price);
      price.classList.add('tw-price-relocated');
      infoList.parentNode.insertBefore(price, infoList);
    }
  }

  function restoreOrder() {
    // Reverse order: each node's recorded next sibling is itself restored first.
    for (var i = moved.length - 1; i >= 0; i--) {
      var record = moved[i];
      if (!record.parent || !record.parent.isConnected) continue;
      var before = record.next && record.next.parentNode === record.parent ? record.next : null;
      record.parent.insertBefore(record.el, before);
      record.el.classList.remove('tw-price-relocated');
    }
    moved.length = 0;
    if (headBox && headBox.parentNode) headBox.parentNode.removeChild(headBox);
  }

  var mobile = window.matchMedia(MOBILE_QUERY);

  function run() {
    try {
      if (mobile.matches) applyMobileOrder();
      else restoreOrder();
    } catch (e) {
      /* fail open */
    }
  }

  if (mobile.addEventListener) mobile.addEventListener('change', run);
  else if (mobile.addListener) mobile.addListener(run);

  // Apps on this storefront inject markup late, so re-run a few times rather
  // than watching the document.
  function boot() {
    run();
    var delays = [100, 400, 1200, 3000];
    for (var i = 0; i < delays.length; i++) setTimeout(run, delays[i]);
  }

  window.addEventListener('load', run);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
